import script from "./edit-task-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-task-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-task-modal.vue?vue&type=style&index=0&id=5aeb2d0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aeb2d0f"]])

export default __exports__